// urls for map icons
export const shopIconUrl = require('@/assets/icons/map/icon-store.svg')
export const shopIconOutlineUrl = require('@/assets/icons/map/icon-store-outline.svg')

export const advertUniqueIconUrl = require('@/assets/icons/map/icon-unique-advert.svg')
export const advertIconUrl = require('@/assets/icons/map/icon-advert.svg')
export const advertClusterSmallIconUrl = require('@/assets/icons/map/cluster-28-advert.svg')
export const advertClusterMediumIconUrl = require('@/assets/icons/map/cluster-36-advert.svg')
export const advertClusterLargeIconUrl = require('@/assets/icons/map/cluster-44-advert.svg')
export const advertSquareUniqueIconUrl = require('@/assets/icons/map/icon-unique-advert-square.svg')
export const advertSquareIconUrl = require('@/assets/icons/map/icon-advert-square.svg')
export const advertSquareClusterSmallIconUrl = require('@/assets/icons/map/cluster-28-advert-square.svg')
export const advertSquareClusterMediumIconUrl = require('@/assets/icons/map/cluster-36-advert-square.svg')
export const advertSquareClusterLargeIconUrl = require('@/assets/icons/map/cluster-44-advert-square.svg')

export const poiIconUrl = require('@/assets/icons/map/icon-store-competitor.svg')
export const productPoiIconUrl = require('@/assets/icons/map/icon-store-competitor-product.svg')

// sizes in px for map icons
export const SHOP_SIZE = 42
export const SHOP_CLUSTER_SIZE = 48

export const ADVERT_SIZE = 24
export const ADVERT_CLUSTER_SIZE = 40
export const ADVERT_CLUSTER_SIZE_BIG = 44

export const ADVERT_SQUARE_SIZE = 32
export const ADVERT_SQUARE_CLUSTER_SIZE = 42

export const ADVERT_TYPES = {
  PRODUCT: 'PRODUCTO',
  SIGN: 'SEÑALIZACIÓN'
}

export function getAdvertSize (type, count) {
  return type === ADVERT_TYPES.PRODUCT
    ? count > 0 && count <= 10
      ? ADVERT_SIZE
      : count > 10 && count <= 99
        ? ADVERT_CLUSTER_SIZE
        : ADVERT_CLUSTER_SIZE_BIG
    : count === 1
      ? ADVERT_SQUARE_SIZE
      : ADVERT_SQUARE_CLUSTER_SIZE
}

const advertSquareTemplate = (color = '#f2f2f4') => `
<svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 36 36">
  <defs>
    <filter x="-20.3%" y="-17.2%" width="140.6%" height="140.6%" filterUnits="objectBoundingBox" id="filter-2">
      <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
      <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
    </filter>
  </defs>
  <g transform="translate(2, 2) rotate(45 16 16)">
    <rect fill="#000000" fill-opacity="1" filter="url(#filter-2)" x="4" y="4" width="24" height="24" />
    <rect fill="${color}" fill-rule="evenodd" x="4" y="4" width="24" height="24" />
  </g>
</svg>
`

const advertCircleTemplate = (color = '#f2f2f4') => `
<svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 36 36">
  <defs>
    <filter x="-20.3%" y="-17.2%" width="140.6%" height="140.6%" filterUnits="objectBoundingBox" id="filter-2">
      <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
      <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
    </filter>
  </defs>
  <g transform="translate(2, 2)">
    <circle fill="#000" fill-opacity="1" filter="url(#filter-2)" cx="16" cy="16" r="16"></circle>
    <circle fill-rule="evenodd" fill="${color}" cx="16" cy="16" r="16"></circle>
  </g>
</svg>
`

export function createAdvertIcon (advertType, color = '#f2f2f4') {
  const template = advertType === ADVERT_TYPES.PRODUCT ? advertCircleTemplate : advertSquareTemplate
  const base = template(color)
  const dataURL = `data:image/svg+xml;base64,${btoa(base)}`
  return dataURL
}

export const ADVERT_COLOR_AVAILABLE = '#e4e5e8'
export const ADVERT_COLOR_SELECTED = '#ffc605'
export const ADVERT_COLOR_RESERVED = '#1069de'
